<template>
  <v-card class="mb-4">
    <v-card-text class="d-flex justify-center py-8">
      <v-progress-circular indeterminate color="primary" size="32" />
    </v-card-text>
  </v-card>
</template>

<script>
  export default {
    name: 'FilialConnectionBlockPlaceholder',
  }
</script>
